<span class="accordion-list__start-icon" [class]="startIconClass">
    <app-icon *ngIf="startIcon !== 'oval-open'" [iconName]="startIcon === 'indeterminate' ? 'check' : startIcon"></app-icon>
</span>
<ng-content></ng-content>
